import { DangerousHtml } from '~components/DangerousHtml';
import { P } from '~components/Typography';

import { promoEventConfig } from '../../config';

export const PromoEventDescription = () => (
	<>
		<DangerousHtml>{promoEventConfig.title}</DangerousHtml>
		<DangerousHtml>{promoEventConfig.eventName}</DangerousHtml>
		<P>
			Use promo code <strong>{promoEventConfig.promoCode}</strong> until{' '}
			{promoEventConfig.validUntil}
		</P>
	</>
);
